<template>
  <v-card>
    <v-card-title>
      <h2 class="modal-title">{{ $t('base.create_period') }}</h2>
    </v-card-title>

    <v-card-content>
      <v-input
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        :label="$t('base.name')"
        v-model="form.name" />
         <v-time-field
         :from="form.loading_time_from"
         :to="form.loading_time_to"
         @updateTime="updateTimeHandler"
         class="mb-3"
         />
    </v-card-content>

    <v-card-actions>
      <v-btn :disabled="!form.name" :loading="loading" @click="onCreate">
        {{ $t('base.add') }}
      </v-btn>

    </v-card-actions>
  </v-card>
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'CreatePeriodModal',
  mixins: [formErrorsMixin],

  data () {
    return {
      form: {
        name: '',
        loading_time_from: '06:00:00',
        loading_time_to: '11:00:00',
      },
      errors: {
        name: null
      },
      loading: false
    }
  },

  methods: {
    async onCreate () {
      if (!this.validateData()) return

      const payload = {
        farm: this.$route.params.farm_id,
        ...this.form
      }

      this.loading = true
      const { errors } = await api.loadings.create(payload)
      if (!errors) {
        this.$emit('update')
        this.$emit('close')
        this.$toasted.show(this.$t('Created'))
      } else {
        this.errors = errors
        this.loading = false

        if (errors[0].name === '5') {
          this.errors.name = ['5']
        }
      }
      this.loading = false
    },
    validateData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
        return false
      } else if (this.form.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
        return false
      }

      if (!this.form.loading_time_from) {
        this.$toasted.show('loading_time_from')
        return false
      }
      if (!this.form.loading_time_to) {
        this.$toasted.show('loading_time_to')
        return false
      }
      return true
    },
    updateTimeHandler (startTime, endTime) {
      this.form.loading_time_from = startTime
      this.form.loading_time_to = endTime
    }
  },
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>